module.exports = __webpack_public_path__ + "static/media/edit.746e29e8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/admin/sections/users/components/user/edit.png
 ** module id = 560
 ** module chunks = 0
 **/